export default __webpack_public_path__ + "static/media/times.7804a6d9.svg";